import {createThemedStyles} from '@/theme';

export const styles = createThemedStyles(() => ({
  etherscanLink: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));
